import type { ReactElement, SVGProps } from 'react';

type MeetingFormContentLabelIconProps = {
  children: ReactElement<SVGProps<SVGSVGElement>>;
};

export default function MeetingFormContentLabelIcon(meetingFormContentLabelIconProps: MeetingFormContentLabelIconProps) {
  const { children } = meetingFormContentLabelIconProps;
  return <div className={'[&_svg]:stroke-icon-secondary hidden w-11 min-w-11 shrink-0 items-center justify-center sm:flex [&_svg]:size-3'}>{children}</div>;
}
